<script setup>
import { useForm } from '@inertiajs/vue3'
import AuthLayout from '@/Layouts/AuthLayout.vue'
import UiButton from '@/Components/UI/UiButton.vue'

defineProps({
  errors:  { type: Object, default: () => ({}) },
  success: { type: String, default: null },
})

const form = useForm({ email: '' })

function submit() {
  form.transform((data) => ({ user: data })).post('/users/password')
}
</script>

<template>
  <AuthLayout title="Reset your password">
    <div
      v-if="success"
      class="mb-4 rounded-[var(--radius-md)] p-3 text-sm"
      :style="{ background: 'var(--okSoft)', border: '1px solid color-mix(in oklab, var(--ok) 35%, transparent)', color: 'var(--ok)' }"
    >
      {{ success }}
    </div>

    <p class="text-sm text-[color:var(--muted)] mb-4">
      Enter your email and we'll send you a reset link.
    </p>

    <form @submit.prevent="submit" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-[color:var(--inkSoft)] mb-1">Email</label>
        <input
          v-model="form.email"
          type="email"
          required
          class="w-full border border-[color:var(--line)] rounded-[var(--radius-md)] bg-[color:var(--surface)] text-[color:var(--ink)] px-3 py-2 text-sm focus:outline-2 focus:outline-[color:var(--accent)]"
        />
        <p v-if="form.errors.email" class="mt-1 text-xs text-[color:var(--danger)]">{{ form.errors.email }}</p>
      </div>

      <UiButton
        type="submit"
        variant="primary"
        :loading="form.processing"
        class="w-full justify-center"
      >
        {{ form.processing ? 'Sending…' : 'Send reset link' }}
      </UiButton>

      <p class="text-center text-sm text-[color:var(--muted)]">
        <a href="/users/sign_in" class="text-[color:var(--accent)] hover:underline">Back to sign in</a>
      </p>
    </form>
  </AuthLayout>
</template>
